import {
  EditModePowerBiIframeWidgetProps,
  ViewModePowerBiIframeWidgetProps,
} from '../renderTypes';
import { TrackEvent, WidgetsCommands } from '../../types';
import {
  ArdoqId,
  PowerBiIframeWidgetAttributes,
  WidgetTypes,
} from '@ardoq/api-types';
import { DashboardBuilderPowerBiIframeWidgetProps } from '../types';
import { Maybe } from '@ardoq/common-helpers';
import { DashboardTrackingEventsNames } from '../../tracking';
import { type I18nLocale } from '@ardoq/i18n';

const ALLOWED_IFRAME_HOST_PATTERNS = [
  'app.powerbi.com',
  'app.powerbi.cn',
  'app.powerbigov.us',
  'app.high.powerbigov.us',
  'app.mil.powerbigov.us',
];

export const isAllowedPowerBiUrl = (url: string): boolean => {
  try {
    const parsed = new URL(url);
    return (
      parsed.protocol === 'https:' &&
      ALLOWED_IFRAME_HOST_PATTERNS.some(
        pattern =>
          parsed.hostname === pattern || parsed.hostname.endsWith(`.${pattern}`)
      )
    );
  } catch {
    return false;
  }
};

export const getViewModePowerBiIframeWidgetProps = ({
  widgetData,
}: {
  widgetData: PowerBiIframeWidgetAttributes;
}): ViewModePowerBiIframeWidgetProps => ({
  _id: widgetData._id,
  layout: widgetData.layout,
  url: widgetData.url,
});

export const getEditModePowerBiIframeWidgetProps = ({
  widgetData: { _id, layout, url, viewValidationErrors },
  commands,
  selectedWidgetId,
  isSaving,
  isInLinkDashboardFiltersMode,
  trackEvent,
}: {
  widgetData: DashboardBuilderPowerBiIframeWidgetProps;
  isInLinkDashboardFiltersMode: boolean;
  selectedWidgetId: Maybe<ArdoqId>;
  isSaving: boolean;
  trackEvent: TrackEvent;
  commands: WidgetsCommands;
  i18nLocale: I18nLocale;
}): EditModePowerBiIframeWidgetProps => ({
  _id,
  layout,
  url,
  hasError: Boolean(viewValidationErrors?.length),
  isInLinkDashboardFiltersMode,
  isSelected: _id === selectedWidgetId,
  isSaving,
  commands: {
    copyWidget: () => {
      trackEvent(
        DashboardTrackingEventsNames.DUPLICATED_POWER_BI_IFRAME_IN_DASHBOARD_BUILDER
      );
      commands.copyWidget(_id);
    },
    selectWidget: () => commands.selectWidget(_id),
    deleteWidget: () => {
      trackEvent(
        DashboardTrackingEventsNames.DELETED_POWER_BI_IFRAME_IN_DASHBOARD_BUILDER
      );
      commands.deleteWidget(_id, WidgetTypes.POWER_BI_IFRAME);
    },
  },
});
